import { LicensesModel, UserModel } from "store/types/usersSlice.types";
import i18n from "i18next";
import { getUserTypesTranslation } from "./constants";

export const parseApiErrorMessage = (error: any): string | null => {
  if (!error || !error.isAxiosError) {
    return null;
  }

  const data = error.response?.data;

  if (!data || typeof data !== "object") {
    return null;
  }

  return data.msg || null;
};

export const calculateUnprotectedLicensesAmount = (licenses: LicensesModel) => {
  return licenses.totalCount - licenses.count;
};

export const makeFirstLetterUppercase = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const formatWebLink = (link: string) => {
  return link.split("//")[1].split("/")[0].replace(/www\./, "");
};

export const getUserTypeFilterOptions = (users: UserModel[]) => {
  const USER_TYPES_TO_TRANSLATION = getUserTypesTranslation();
  const uniqueUserTypes = Array.from(new Set(users.map((user) => user.userType)));
  const options = uniqueUserTypes.map((userType) => ({
    label: USER_TYPES_TO_TRANSLATION[userType] || userType,
    value: userType,
  }));

  return [{ label: i18n.t("usersListPage:All"), value: "all" }, ...options];
};

export const getUserStatusFilterOptions = (users: UserModel[]) => {
  const options = Array.from(
    new Set(
      users.map((user) => (user.backedUp ? i18n.t("usersListPage:Protected") : i18n.t("usersListPage:Unprotected")))
    )
  ).filter(Boolean);

  return [
    { label: i18n.t("usersListPage:All"), value: "all" },
    ...options.map((option) => ({
      label: String(option),
      value: String(option),
    })),
  ];
};

export const capitalize = (text: string): string => {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const formatStorageSize = (valueInGb: number): string => {
  if (valueInGb >= 1024) {
    return `${(valueInGb / 1024).toFixed(3)} TB`;
  }

  return `${valueInGb.toFixed(2)} GB`;
};

export const formatNumber = (value: number): string => {
  return value.toLocaleString("fr-FR");
};
